import { render, staticRenderFns } from "./uploadPdf.vue?vue&type=template&id=5dd47f88&"
import script from "./uploadPdf.vue?vue&type=script&lang=js&"
export * from "./uploadPdf.vue?vue&type=script&lang=js&"
import style0 from "./uploadPdf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports